/**
 * Parses a response that can be either empty or json
 */
export const parsePossiblyEmptyResponse = async <T>(
  response: Response
): Promise<T> => {
  try {
    const json = await response.json();
    return json;
  } catch (error) {
    return {} as T;
  }
};
